import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAboutPageData } from '../../services/api';

function AboutFour() {
    const [aboutData, setAboutData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchAboutData();
    }, []);

    const fetchAboutData = async () => {
        try {
            setLoading(true);
            const response = await getAboutPageData();
            setAboutData(response.data);
            setError(null);
        } catch (err) {
            console.error('Error fetching about data:', err);
            setError('Failed to load about data');
            // Use fallback data
            setAboutData({
                hero_subtitle: "Welcome To Tourm",
                main_title: "We are world reputeted travel agency",
                main_content: "There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words.",
                value1_title: "Exclusive Trip",
                value1_description: "There are many variations of passages of available but the majority.",
                value2_title: "Safety First Always",
                value2_description: "There are many variations of passages of available but the majority.",
                about_image1: "/assets/img/normal/about_3_1.jpg"
            });
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="about-area space"><div className="container"><div className="text-center">Loading...</div></div></div>;
    }

    return (
        <div className="about-area position-relative overflow-hidden overflow-hidden space" id="about-sec">
            <div className="container shape-mockup-wrap">
                <div className="row">
                    <div className="col-xl-7">
                        <div className="img-box3">
                            <div className="img1">
                                <img src={aboutData?.about_image1 || "/assets/img/normal/about_3_1.jpg"} alt="About" />
                            </div>
                            <div className="img2">
                                <img src={aboutData?.about_image2 || "/assets/img/normal/about_3_2.jpg"} alt="About" />
                            </div>
                            <div className="img3 movingX">
                                <img src={aboutData?.about_image3 || "/assets/img/normal/about_3_3.jpg"} alt="About" />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5">
                        <div className="ps-xl-4">
                            <div className="title-area mb-20">
                                <span className="sub-title style1">{aboutData?.hero_subtitle || "Welcome To Tourm"}</span>
                                <h2 className="sec-title mb-20 pe-xl-5 me-xl-5 heading">
                                    {aboutData?.main_title || "We are world reputeted travel agency"}
                                </h2>
                            </div>
                            <p className="pe-xl-5">
                                {aboutData?.main_content || "There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words."}
                            </p>
                            <p className="mb-30 pe-xl-5">
                                {aboutData?.mission_statement || "Leiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."}
                            </p>
                            <div className="about-item-wrap">
                                <div className="about-item style2">
                                    <div className="about-item_img">
                                        <img src="/assets/img/icon/about_1_1.svg" alt="" />
                                    </div>
                                    <div className="about-item_centent">
                                        <h5 className="box-title">{aboutData?.value1_title || "Exclusive Trip"}</h5>
                                        <p className="about-item_text">
                                            {aboutData?.value1_description || "There are many variations of passages of available but the majority."}
                                        </p>
                                    </div>
                                </div>
                                <div className="about-item style2">
                                    <div className="about-item_img">
                                        <img src="/assets/img/icon/about_1_2.svg" alt="" />
                                    </div>
                                    <div className="about-item_centent">
                                        <h5 className="box-title">{aboutData?.value2_title || "Safety First Always"}</h5>
                                        <p className="about-item_text">
                                            {aboutData?.value2_description || "There are many variations of passages of available but the majority."}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-group justify-content-start">
                                <Link to="/contact" className="th-btn style4 th-icon">
                                    {aboutData?.cta_button_text || "Get Started"}
                                </Link>
                                <div className="call-btn">
                                    <div className="play-btn">
                                        <i className="fas fa-play" />
                                    </div>
                                    <div className="media-body">
                                        <p className="call-btn_text">Call us on:</p>
                                        <Link className="call-btn_link" to="tel:+256705577823">
                                            +256 705 577 823
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Shape Elements */}
                <div className="shape-mockup spin d-none d-xxl-block" style={{ bottom: '0%', left: '0%' }}>
                    <img src="/assets/img/shape/shape_2_1.png" alt="shape" />
                </div>
                <div className="shape-mockup movingX d-none d-xxl-block" style={{ top: '30%', right: '5%' }}>
                    <img src="/assets/img/shape/shape_2_2.png" alt="shape" />
                </div>
                <div className="shape-mockup spin d-none d-xxl-block" style={{ top: '18%', left: '-112%' }}>
                    <img src="/assets/img/shape/shape_2_3.png" alt="shape" />
                </div>
                <div className="shape-mockup movixgX d-none d-xxl-block" style={{ bottom: '18%', right: '-12%' }}>
                    <img src="/assets/img/shape/shape_2_4.png" alt="shape" />
                </div>
            </div>
        </div>
    )
}

export default AboutFour
